import type { Components } from "@mui/material/styles";

export const MuiFormControlLabel: Components["MuiFormControlLabel"] = {
  styleOverrides: {
    root: {
      ".MuiFormControlLabel-label": {
        fontSize: "var(--font-size-m)",
      },
    },
  },
};

export const MuiFormLabel: Components["MuiFormLabel"] = {
  styleOverrides: {
    root: {
      fontSize: "var(--font-size-m)",
      fontWeight: 500,
      lineHeight: "var(--base-line-height)",
      color: "var(--color-black)",
    },
  },
};
